<template>
  <v-col class="ma-0 pa-0" cols="12">
		<template v-if="currentView == 'selectCount'">
			<SelectCameraCount :splitListCount="splitScreenList.length"
        @selectedCameraCount="selectedCameraCountFunc"
        @selectCancel="selectCancelFunc" />
		</template>
		<template v-else-if="currentView == 'selectCamera'">
			<SelectCamera :viewCount="selectedCameraCount" @cancel="cancelFunc" 
				@addSuccess="addSuccessFunc" />
		</template>
		<template v-else-if="currentView == 'selectSplitPlayer'">
			<SplitPlayer :viewCount="selectedCameraCount" @newSplit="newSplitFunc"
                   @changeViewCount="changeViewCountFunc"
                   @updateSplitScreenList="updateSplitScreenListFunc" />
		</template>
		<template v-else>
			<v-col class="ma-0 pa-10 mt-10" cols="12">
				<v-progress-circular indeterminate color="white"
          :width="6" :size="50"></v-progress-circular>
			</v-col>
		</template>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import SelectCameraCount from './SelectCameraCount.vue';
import SelectCamera from './SelectCamera.vue';
import SplitPlayer from './SplitPlayer.vue';
export default {
	components: {
		SelectCameraCount, SelectCamera, SplitPlayer
	},
	mixins: [mixin.common],
	data: () => ({
		currentView: 'loading',
		selectedCameraCount: 4,
		splitScreenData: null,
		splitScreenList: [],
	}),
	mounted() {
		this.getSplitList();
	},
	methods: {
		selectedCameraCountFunc(count) {
			this.selectedCameraCount = count;
			this.currentView = 'selectCamera';
		},
    selectCancelFunc(status) {
      this.currentView = 'selectSplitPlayer';
    },
		cancelFunc(status) {
			this.currentView = 'selectCount';
		},
		addSuccessFunc(splitData) {
			this.splitScreenData = splitData;
      this.$store.commit('setSelectedSplitScreen', splitData.splitName);
			this.currentView = 'selectSplitPlayer';
		},
		newSplitFunc(status) {
			this.currentView = 'selectCount';
		},
		changeViewCountFunc(cnt) {
			this.selectedCameraCount = cnt;
		},
    updateSplitScreenListFunc(data) {
      this.splitScreenList = data;
      this.$store.commit('setAllPrivateSplitScreenList', data);
    },
		getSplitList() { 
			// 분할 화면 리스트 데이터 받아오기
      let params = {};
      this.networkController.getPrivateUserSplitScreenList(params)
      .then((res) => {
        this.splitScreenList = res.data;
				this.$store.commit('setAllPrivateSplitScreenList', res.data);
        console.log('getSplitList', this.splitScreenList.length, this.currentView);
				if(this.splitScreenList.length > 0) this.currentView = 'selectSplitPlayer';
				else this.currentView = 'selectCount';
      }).catch(error => {
				this.currentView = 'selectCount';
			});
    },
	}
}
</script>

<style lang="scss" scoped>
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	border-radius: 5px;
	max-width: 700px;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
}
</style>